import Reflux from 'reflux';
import EventDocData from 'shared/data/EventDoc';

let async = { asyncResult: true },
  EventDocFormActions = Reflux.createActions({
    populate: {},
    submitMany: {},
    create: async,
    update: async,
  });

EventDocFormActions.create.listenAndPromise(EventDocData.upload);
EventDocFormActions.update.listenAndPromise(EventDocData.update);

export default EventDocFormActions;
